export const wanted_headers = [
  "frm",
  "tng1x",
  "tng1y",
  "tng2x",
  "tng2y",
  "tng3x",
  "tng3y",
  "tng4x",
  "tng4y",
  "tng5x",
  "tng5y",
  "tng6x",
  "tng6y",
  "tng7x",
  "tng7y",
  "tng8x",
  "tng8y",
  "tng9x",
  "tng9y",
  "tng10x",
  "tng10y",
  "tng11x",
  "tng11y",
  "tng12x",
  "tng12y",
  "tng13x",
  "tng13y",
  "tng14x",
  "tng14y",
  "tng15x",
  "tng15y",
  "tng16x",
  "tng16y",
  "tng17x",
  "tng17y",
  "tng18x",
  "tng18y",
  "tng19x",
  "tng19y",
  "tng20x",
  "tng20y",
  "tng21x",
  "tng21y",
  "tng22x",
  "tng22y",
  "tng23x",
  "tng23y",
  "tng24x",
  "tng24y",
  "tng25x",
  "tng25y",
  "tng26x",
  "tng26y",
  "tng27x",
  "tng27y",
  "tng28x",
  "tng28y",
  "tng29x",
  "tng29y",
  "tng30x",
  "tng30y",
  "tng31x",
  "tng31y",
  "tng32x",
  "tng32y",
  "tng33x",
  "tng33y",
  "tng34x",
  "tng34y",
  "tng35x",
  "tng35y",
  "tng36x",
  "tng36y",
  "tng37x",
  "tng37y",
  "tng38x",
  "tng38y",
  "tng39x",
  "tng39y",
  "tng40x",
  "tng40y",
  "ulp1x",
  "ulp1y",
  "ulp2x",
  "ulp2y",
  "ulp3x",
  "ulp3y",
  "ulp4x",
  "ulp4y",
  "ulp5x",
  "ulp5y",
  "ulp6x",
  "ulp6y",
  "ulp7x",
  "ulp7y",
  "ulp8x",
  "ulp8y",
  "ulp9x",
  "ulp9y",
  "ulp10x",
  "ulp10y",
  "ulp11x",
  "ulp11y",
  "ulp12x",
  "ulp12y",
  "ulp13x",
  "ulp13y",
  "ulp14x",
  "ulp14y",
  "ulp15x",
  "ulp15y",
  "llp1x",
  "llp1y",
  "llp2x",
  "llp2y",
  "llp3x",
  "llp3y",
  "llp4x",
  "llp4y",
  "llp5x",
  "llp5y",
  "llp6x",
  "llp6y",
  "llp7x",
  "llp7y",
  "llp8x",
  "llp8y",
  "llp9x",
  "llp9y",
  "llp10x",
  "llp10y",
  "llp11x",
  "llp11y",
  "llp12x",
  "llp12y",
  "llp13x",
  "llp13y",
  "llp14x",
  "llp14y",
  "llp15x",
  "llp15y",
  "llp16x",
  "llp16y",
  "llp17x",
  "llp17y",
  "llp18x",
  "llp18y",
  "llp19x",
  "llp19y",
  "llp20x",
  "llp20y",
  "llp21x",
  "llp21y",
  "llp22x",
  "llp22y",
  "llp23x",
  "llp23y",
  "llp24x",
  "llp24y",
  "llp25x",
  "llp25y",
  "plt1x",
  "plt1y",
  "plt2x",
  "plt2y",
  "plt3x",
  "plt3y",
  "plt4x",
  "plt4y",
  "plt5x",
  "plt5y",
  "plt6x",
  "plt6y",
  "plt7x",
  "plt7y",
  "plt8x",
  "plt8y",
  "plt9x",
  "plt9y",
  "plt10x",
  "plt10y",
  "plt11x",
  "plt11y",
  "plt12x",
  "plt12y",
  "plt13x",
  "plt13y",
  "plt14x",
  "plt14y",
  "plt15x",
  "plt15y",
  "plt16x",
  "plt16y",
  "plt17x",
  "plt17y",
  "plt18x",
  "plt18y",
  "plt19x",
  "plt19y",
  "plt20x",
  "plt20y",
  "plt21x",
  "plt21y",
  "plt22x",
  "plt22y",
  "plt23x",
  "plt23y",
  "plt24x",
  "plt24y",
  "plt25x",
  "plt25y",
  "plt26x",
  "plt26y",
  "plt27x",
  "plt27y",
  "plt28x",
  "plt28y",
  "plt29x",
  "plt29y",
  "plt30x",
  "plt30y",
  "pwl1x",
  "pwl1y",
  "pwl2x",
  "pwl2y",
  "pwl3x",
  "pwl3y",
  "pwl4x",
  "pwl4y",
  "pwl5x",
  "pwl5y",
  "pwl6x",
  "pwl6y",
  "pwl7x",
  "pwl7y",
  "pwl8x",
  "pwl8y",
  "pwl9x",
  "pwl9y",
  "pwl10x",
  "pwl10y",
  "pwl11x",
  "pwl11y",
  "pwl12x",
  "pwl12y",
  "pwl13x",
  "pwl13y",
  "pwl14x",
  "pwl14y",
  "pwl15x",
  "pwl15y",
  "pwl16x",
  "pwl16y",
  "pwl17x",
  "pwl17y",
  "pwl18x",
  "pwl18y",
  "pwl19x",
  "pwl19y",
  "pwl20x",
  "pwl20y",
  "pwl21x",
  "pwl21y",
  "pwl22x",
  "pwl22y",
  "pwl23x",
  "pwl23y",
  "pwl24x",
  "pwl24y",
  "pwl25x",
  "pwl25y",
  "pwl26x",
  "pwl26y",
  "pwl27x",
  "pwl27y",
  "pwl28x",
  "pwl28y",
  "awl1x",
  "awl1y",
  "awl2x",
  "awl2y",
  "awl3x",
  "awl3y",
  "awl4x",
  "awl4y",
  "awl5x",
  "awl5y",
  "awl6x",
  "awl6y",
  "awl7x",
  "awl7y",
  "awl8x",
  "awl8y",
  "awl9x",
  "awl9y",
  "awl10x",
  "awl10y",
  "awl11x",
  "awl11y",
  "awl12x",
  "awl12y",
  "awl13x",
  "awl13y",
  "awl14x",
  "awl14y",
  "awl15x",
  "awl15y",
  "awl16x",
  "awl16y",
  "awl17x",
  "awl17y",
  "awl18x",
  "awl18y",
  "awl19x",
  "awl19y",
  "awl20x",
  "awl20y",
  "awl21x",
  "awl21y",
  "awl22x",
  "awl22y",
  "awl23x",
  "awl23y",
  "awl24x",
  "awl24y",
  "awl25x",
  "awl25y",
  "awl26x",
  "awl26y",
  "awl27x",
  "awl27y",
  "awl28x",
  "awl28y",
  "awl29x",
  "awl29y",
  "awl30x",
  "awl30y"
];
export const row_index = {
  frm: 1,
  tng: 40,
  ulp: 15,
  llp: 25,
  plt: 30,
  upw: 28,
  atw: 30
};
